<div class="panelPopup">
  <div class="header-section">
    <div class="car-icon-container">
      <img [src]="iconImage | findUrl" alt="Car Icon" class="car-icon">
    </div>
  </div>

  <div class="nav-section">
    <mat-icon class="back-arrow" (click)="cancel()">arrow_back</mat-icon>
    <img [src]="'reporte_azul.svg' | findUrl" alt="Report Icon" class="report-icon">
    <span class="nav-text">Reportes</span>
  </div>

  <div mat-dialog-content class="content-section">
    <form [formGroup]="formGroup">
      <div class="section-title">Fecha de reporte</div>

      <div class="custom-date-selector" (click)="rangePicker.open()">
        <div class="date-selector-top">
          <label class="date-label">Desde - Hasta:</label>
          <div class="calendar-icon-btn">
            <mat-icon>calendar_today</mat-icon>
          </div>
        </div>
        <div class="date-separator"></div>
        <div class="date-selector-bottom">
          <span class="date-value">{{ formGroup.get('initialDate').value | date:'dd/MM/yyyy' }} - {{ formGroup.get('finalDate').value | date:'dd/MM/yyyy' }}</span>
        </div>
        <mat-form-field class="hidden-datepicker">
          <mat-date-range-input [rangePicker]="rangePicker" [min]="minStartDate" [max]="maxEndDate">
            <input matStartDate formControlName="initialDate" (dateInput)="limteFecha($event)">
            <input matEndDate formControlName="finalDate">
          </mat-date-range-input>
          <mat-date-range-picker #rangePicker></mat-date-range-picker>
        </mat-form-field>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="footer-section">
    <button mat-button class="btnAccept" (click)="accept()" [disabled]="formGroup.invalid">Descargar</button>
  </div>
</div>



